import _get from 'lodash/get';
import {
  FilterGroupingEnum,
  FormTemplateQuestionFieldOptionsValidityHintEnum,
  TaskFilterInputObject,
} from 'graphql-common';
import MonitoringFilterFieldNames from '@lib/enums/fieldNames/monitoringFilterFieldNames';
import { Values, Option } from '@lib/interfaces/form';
import { StatusKind, MonitoringEntity } from '../enums';
import getFilterFieldNameByMonitoringEntity from './getFilterFieldNameByMonitoringEntity';
import getStatusKind from './getStatusKind';

export default function getAdditionalTaskFilters({
  filterParams,
  monitoringEntity,
}: {
  filterParams: Values;
  monitoringEntity: MonitoringEntity;
}) {
  const filters: TaskFilterInputObject[] = [];
  const period = _get(
    filterParams,
    getFilterFieldNameByMonitoringEntity(
      monitoringEntity,
      MonitoringFilterFieldNames.Period,
    ),
    [],
  );
  const statusKind = getStatusKind({ filterParams });
  const filterByFormCategory = _get(
    filterParams,
    getFilterFieldNameByMonitoringEntity(
      monitoringEntity,
      MonitoringFilterFieldNames.FormCategory,
    ),
    [],
  ) as Option[];
  const filterByFormTemplateName = _get(
    filterParams,
    getFilterFieldNameByMonitoringEntity(
      monitoringEntity,
      MonitoringFilterFieldNames.FormTemplateName,
    ),
    [],
  ) as Option[];

  if (statusKind === StatusKind.DeadlineMissed) {
    if (period?.[0]) {
      filters.push({
        deadlineAt: {
          grouping: FilterGroupingEnum.And,
          predicate: { gteq: period[0] },
          filterGroup: 'deadlineAt',
        },
      });
    }
    if (period?.[1]) {
      filters.push({
        deadlineAt: {
          grouping: FilterGroupingEnum.And,
          predicate: { lteq: period[1] },
          filterGroup: 'deadlineAt',
        },
      });
    }
  } else {
    if (period?.[0]) {
      filters.push({
        completedAt: {
          grouping: FilterGroupingEnum.And,
          predicate: { gteq: period[0] },
          filterGroup: 'completedAt',
        },
      });
    }
    if (period?.[1]) {
      filters.push({
        completedAt: {
          grouping: FilterGroupingEnum.And,
          predicate: { lteq: period[1] },
          filterGroup: 'completedAt',
        },
      });
    }
  }

  if (statusKind !== StatusKind.DeadlineMissed) {
    const hints: string[] = [
      FormTemplateQuestionFieldOptionsValidityHintEnum.Success,
    ];
    if (
      statusKind === StatusKind.Warning ||
      statusKind === StatusKind.WarningAndAlert
    ) {
      hints.push(FormTemplateQuestionFieldOptionsValidityHintEnum.Warning);
    }
    if (
      statusKind === StatusKind.Alert ||
      statusKind === StatusKind.WarningAndAlert
    ) {
      hints.push(FormTemplateQuestionFieldOptionsValidityHintEnum.Failure);
    }
    if (hints.length) {
      filters.push({
        completionValidityHint: {
          grouping: FilterGroupingEnum.And,
          predicate: { in: hints },
        },
      });
    }
  }

  if (filterByFormCategory?.length) {
    filters.push({
      formCategoryId: {
        grouping: FilterGroupingEnum.And,
        predicate: {
          in: filterByFormCategory.map(({ value }) => value as string),
        },
      },
    });
  }

  if (filterByFormTemplateName?.length) {
    filters.push({
      templateId: {
        grouping: FilterGroupingEnum.And,
        predicate: {
          in: filterByFormTemplateName.map(({ value }) => value as string),
        },
      },
    });
  }

  return filters;
}
